import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLang } from '../../contexts/LangContext';

export const SignOutButton: React.FC = () => {
  const { logout } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();

  const handleSignOut = () => {
    logout();
    navigate('/login');
  };

  return (
    <button
      onClick={handleSignOut}
      className="px-3 py-2 rounded bg-red-500 text-white hover:bg-red-600 mt-4"
    >
      {t('signOut')}
    </button>
  );
}; 